const provinces_ids = {
    "koshi":1,
    "madhesh":2,
    "bagmati":3,
    "gandaki":4,
    "lumbini":5,
    "karnali":6,
    "sudurpashchim":7,
  }

export default provinces_ids;